export const isArrayEmpty = (items: any[] | ReadonlyArray<any> | undefined): boolean =>
  !!items && items.length === 0;
